import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from "file-saver";
import { Subscription } from 'rxjs';
import { InfoDialogComponent } from '../../../../dialogs/info-dialog/info-dialog.component';
import { RelatorioDTO } from '../../../../dtos/relatorio-dto';
import { CustomDateValidator } from '../../../../validators/custom-date-validator';
import { RelatorioGlobalService } from '../../relatorio-global.service';
import { Util } from '../../../../util/util';
import { ChaveValorStrInterface } from '../../../../util/chave-valor-str-interface';

@Component({
  selector: 'app-rel-marcacao-interna-global',
  templateUrl: './rel-marcacao-interna-global.component.html',
  styleUrls: ['./rel-marcacao-interna-global.component.css']
})
export class RelMarcacaoInternaGlobalComponent implements OnInit, OnDestroy {

  formularioGlobalDeMarcacoesInternas: FormGroup;

  listaTipoAgrupamentoParaMarcacaoInterna: ChaveValorStrInterface[];

  gerarRelatorioDeMarcacoesInternasSubscription: Subscription | null = null;

  constructor(private relatorioGlobalService: RelatorioGlobalService,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    private datepipe: DatePipe,
    private dialog: MatDialog) {

    this.formularioGlobalDeMarcacoesInternas = this.formBuilder.group({
      dataInicial: [''],
      dataFinal: [''],
      codTipoAgrupamento: ['0', [Validators.required]],
    }, {
      validator: [CustomDateValidator('dataInicial'),
      CustomDateValidator('dataFinal')],
    });

    this.listaTipoAgrupamentoParaMarcacaoInterna = Util.listaTipoAgrupamentoParaMarcacaoInterna;
  }

  ngOnInit() {
  }

  onSubmit() {
    this.generateReport();
  }

  generateReport() {

    const relatorioDTO: RelatorioDTO = Object.assign(new RelatorioDTO(), this.formularioGlobalDeMarcacoesInternas.value);

    this.gerarRelatorioDeMarcacoesInternasSubscription =

      this.relatorioGlobalService.gerarRelatorioDeMarcacoesInternas(relatorioDTO)
        .subscribe(blob => {

          if (blob) {
            let fileName = 'cope_marcacao_interna_' +
              this.datepipe.transform((new Date()), 'ddMMyyyyHHmmss') + '.xlsx';

            saveAs(blob, fileName)
          } else {
            this.dialog.open(InfoDialogComponent, {
              data: {
                title: 'Info',
                message: 'Não foram encontradas marcações para o período informado!'
              }
            });
          }
        });
  }

  ngOnDestroy() {
    this.unsubscribeItems();
  }

  unsubscribeItems() {
    this.gerarRelatorioDeMarcacoesInternasSubscription?.unsubscribe();
  }
}

